import gql from 'graphql-tag';

export const queryForCommercialOutages = gql`
  query queryForCommercialOutages(
    $limit: Int!
    $page: Int!
    $query: CommercialOutageSortOrQuery
    $sort: CommercialOutageSortOrQuery
  ) {
    queryForCommercialOutages(
      limit: $limit
      page: $page
      query: $query
      sort: $sort
    ) {
      items {
        id
        version
        outageStartDate
        outageEndDate
        numberOfUnitsOnOutage
        numberOfTotalUnits
        CommercialFacility {
          facilityName
          facilityId
        }
        AOR {
          name
        }
        CommercialOperatingArea {
          name
        }
        CommercialMarketArea {
          name
        }
      }
      totalRecords
    }
  }
`;
